import * as yup from "yup";

const getFieldProps = (formik, name) => ({
  ...formik.getFieldProps(name),
  disabled: formik.isSubmitting,
  isInvalid: formik.touched[name] && !!formik.errors[name]
});

const filterFields = (profile, fields) => {
  const res = {};
  fields.forEach(field => {
    res[field] = (profile && profile[field]) || "";
  });
  return res;
};

// returns whether pattern is a subsequence of text
// must match first character
// text, pattern: non empty lowercase string
const matchText = (text, pattern) => {
  if (!text || text.length === 0) return false;
  if (!pattern || pattern.length === 0) return false;
  if (text[0] !== pattern[0]) return false;
  var i = 1;
  for (var j = 1; j < pattern.length; j++) {
    while (i < text.length && text[i] !== pattern[j]) i++;
    if (i >= text.length) return false;
    i++;
  }
  return true;
};

// separate text and pattern into words
const sep = /[,;/() ]+/;
const matchAllText = (text, pattern) => {
  if (!text || text.length === 0) return false;
  if (!pattern || pattern.length === 0) return false;
  const textWords = text
    .trim()
    .toLowerCase()
    .split(sep)
    .join('');
  const patternWords = pattern
    .trim()
    .toLowerCase()
    .split(sep)
    .join('');
  return matchText(textWords, patternWords);
};

const validTextRegex = /^[a-zA-Z][a-zA-Z0-9()'.,/& ]*$/;

const validString = label =>
  yup
    .string()
    .strict()
    .trim(`${label} must not have any leading or trailing spaces`)
    .matches(validTextRegex, `${label} must be in English`);

const validRequiredString = label =>
  validString(label).required(`${label} is required`);

export {
  getFieldProps,
  filterFields,
  matchAllText,
  validString,
  validRequiredString
};
